import { Logger } from '../../generic/utils';
import { wrapperIdentifier } from './common';
import { useEffect } from 'react';
import { SESSION_STATUSES } from '../../wrappers/SessionWrapper/others';
import { wrapperBuilder } from './build';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}
let lastToken: string | undefined = undefined;

wrapperBuilder.getCustomLogicRegisterInstance().setLogic(
  ({
    functions: { loadSessionUser },
    variablesHandler: {
      variables: { user },
      variablesSetter,
    },
    bindedContexts: { sessionStatus, token },
  }) => {
    useEffect(() => {
      console.log(' SESSION STATUS ', sessionStatus);
      if (sessionStatus === SESSION_STATUSES.CREATED) {
        if (token && token !== lastToken) {
          lastToken = token;
          console.log('Loading user');
          loadSessionUser();
        }
      } else if (sessionStatus === SESSION_STATUSES.NOT_CREATED) {
        lastToken = undefined;
        lastToken = undefined;
        if (user) {
          variablesSetter('user')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, sessionStatus]);
  }
);
